export default "__VITE_ASSET__BlxEdk0l__"